import * as Social from "./Social";

export default {
  ...Social,
};
